import { render, staticRenderFns } from "./registerscreenTwo.component.vue?vue&type=template&id=5bdaef44&scoped=true"
import script from "./registerscreenTwo.component.vue?vue&type=script&lang=js"
export * from "./registerscreenTwo.component.vue?vue&type=script&lang=js"
import style0 from "./registerscreenTwo.component.vue?vue&type=style&index=0&id=5bdaef44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bdaef44",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VBtn,VCard})
